/**
 * @param PaymentAccordionItem Base widget for extending
 * @returns CASH_ON_DELIVERY Payment Accordion Item widget
 */
function PaymentAccordionItemCashOnDeliveryClassCreator(PaymentAccordionItem: import('widgets/checkout/PaymentAccordionItem').TPaymentAccordionItem) {
    /**
     * @category widgets
     * @subcategory checkout
     * @class PaymentAccordionItemCashOnDelivery
     * @augments PaymentAccordionItem
     * @classdesc Represents PaymentAccordionItemCashOnDelivery component with the next features:
     * 1. Handles payment tab submit
     * 2. Validates payment tab child elements
     *
     * @example <caption>Example of PaymentAccordionItemCashOnDelivery widget usage</caption>
     * <section
     *     data-widget="paymentAccordionItem${paymentOption.ID}"
     *     data-widget-event-closeallitems="closeItems"
     *     data-widget-event-accordionitemupdate="updateFocusedItem"
     *     data-expanded="true"
     *     data-method-id="${paymentOption.ID}"
     *     data-method-name="${paymentOption.name}"
     *     data-widget-event-openpanel="hidePaymentError"
     *     data-tau-payment-id="${paymentOption.ID}"
     *     class="b-payment_accordion-item"
     * >
     *     <isinclude template="checkout/billing/paymentOptions/paymentTitle_CASH_ON_DELIVERY" />
     * </section>
     */
    class PaymentAccordionItemCashOnDelivery extends PaymentAccordionItem {
        /**
         * @description Handles CASH_ON_DELIVERY payment tab submit
         * @returns result
         */
        process(): Promise<[]> {
            return Promise.resolve([]);
        }

        /**
         * @description Validates CASH_ON_DELIVERY payment tab child elements.
         * @returns validation result
         */
        isChildrenValid(): boolean {
            return true;
        }
    }

    return PaymentAccordionItemCashOnDelivery;
}

export type TPaymentAccordionItemCashOnDelivery = ReturnType<typeof PaymentAccordionItemCashOnDeliveryClassCreator>;

export type TPaymentAccordionItemCashOnDeliveryInstance = InstanceType<TPaymentAccordionItemCashOnDelivery>;

export default PaymentAccordionItemCashOnDeliveryClassCreator;
